




















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { FileHelper as _file } from '@/helper/file.helper';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { paymentService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    postingDate: {
      get() {
        return this.currentDate;
      },
      set(value) {
        return value;
      },
    },
    formattedStartDate: {
      get() {
        if (this.reconcilPostingDate) {
          const d = this.formatDate(this.reconcilPostingDate);
          // this.params.endDate = this.reconcilPostingDate;
          let lastDate = _dateTime.currentDate(
            _dateTime.addDays(new Date(this.reconcilPostingDate), 45)
          );
          if (lastDate > this.todayDate) {
            lastDate = this.todayDate;
          }
          this.maxToDate = lastDate;
          return d;
        } else {
          return _dateTime.currentDate(new Date());
        }
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Calendar: () => import('@/components/common/app.calendar.vue'),
    Datepicker: () => import('@/components/common/app.datepicker.vue'),
  },
})
export default class ReconcilePage extends Base {
  public reconcilList: any[] = [];
  public reconcilCashBackList: any[] = [];

  public reconcilHeader: VHeaders[] = [];
  public reconcileSubHeader: VHeaders[] = [];

  public selectedAttachments = [];
  public totalNetAmount: any = 0;
  public sumOfFee: any = 0;
  public currentDate: string = this.postingDate(new Date());
  public statementId: string = '';
  public statusList: any[] = [
    {
      id: 1,
      text: 'All',
    },
    {
      id: 2,
      text: 'Pending',
    },
    {
      id: 3,
      text: 'Success',
    },
  ];

  public selected: any[] = [];
  public actions: any[] = [];
  public subActions: any[] = [];

  public pagination = new PaginationModel('initiatedAt', true);
  public childPagination = new PaginationModel('initiatedAt', true, -1);

  constructor() {
    super();
  }

  public maxToDate: any = _dateTime.currentDate(
    _dateTime.addDays(new Date(), 45)
  );
  public todayDate: any = _dateTime.currentDate(new Date());

  public flags: any = {
    showStartDatePicker: false,
    showEndDatePicker: false,
  };
  public reconcilPostingDate = '';

  public params: any = {
    startDate: '',
    endDate: '',
  };

  public startDateFlag: string = '';
  public formattedStartDate: string;
  public cashBackStatus: string = '';

  public validateStartDate(date) {
    this.startDateFlag = date;
    const re = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    const validate = re.test(String(date));
    if (validate) {
      const formatedDate = _dateTime.currentDate(new Date(date));
      this.reconcilPostingDate = formatedDate;
    }
    return re.test(String(date));
  }

  public formatDate(date) {
    if (!date) {
      return null;
    }
    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  }

  public loading: boolean = false;
  public resetFilter: boolean = false;

  // Dialog
  public syncDialog: IDialogOption = {
    width: 400,
    title: 'Post To DMS',
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: 'Submit',
      disable: false,
    },
    onAction: (): void => {
      this.postDmsData();
    },
    onClose: (): void => {
      this.onCloseDmsPopup();
    },
  };

  public onCloseDmsPopup() {
    this.statementId = '';
    this.totalNetAmount = '';
    this.sumOfFee = '';
  }

  public getPaymentResponse(model: any): any {
    const result = this.reconcilCashBackList.filter(
      (x) =>
        x.statementId == model.statementId && x.cashBackStatus == 'CashBack'
    );

    return result;
  }

  public async postDmsData() {
    try {
      if (this.currentDate == '') {
        this.showAlert(false, 'Please select Posting Date');
        return;
      }
      this.syncDialog.action.disable = true;
      let postingDate = this.reconcilPostingDate || this.currentDate;
      var response = await paymentService.reconcilePayments(
        this.statementId,
        postingDate,
        this.cashBackStatus
      );
      if (response.status) {
        this.showAlert(true, response.responseMessage);
      } else {
        this.showAlert(false, response.responseMessage);
      }
      this.syncDialog.action.disable = true;
      this.getReconcilationListPayments();
    } finally {
      this.syncDialog.action.disable = false;
      this.syncDialog.model = false;
      this.selectedAttachments = [];
      this.statementId = '';
      this.totalNetAmount = '';
      this.sumOfFee = '';
    }
  }

  public resetFilters() {
    this.params.endDate = '';
    this.params.startDate = '';
    this.resetFilter = !this.resetFilter;
    this.setInvoiceDateParmsGlAccount([]);
  }

  public setInvoiceDateParmsGlAccount(dates: any) {
    if (dates.length > 0) {
      if (dates[0]) {
        this.params.startDate = dates[0];
      } else {
        this.params.startDate = '';
      }
      if (dates[1]) {
        this.params.endDate = dates[1];
      } else {
        this.params.endDate = '';
      }
    }
  }

  public postingDate(date?): string {
    if (!date && typeof date !== 'function') {
      date = new Date();
    }

    let month = (date.getMonth() + 1).toString();
    if (Number(month) < 10) {
      month = '0' + month;
    }

    let day = date.getDate().toString();
    if (Number(day) < 10) {
      day = '0' + day;
    }
    const d = `${date.getFullYear()}-${month}-${day}`;
    return d;
  }

  public setActions() {
    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-eye',
        title: 'View Statements',
        action: (model: any) => {
          return {
            name: 'app.paymentreports.reconciliation.edit',
            params: { id: model.statementId, type: model.cashBackStatus },
          };
        },
      },
      {
        type: 'button',
        icon: 'far fa-eye',
        title: 'View Cost Plus Adjustment Detail',
        visible: (model: any) => {
          if (
            model.cashBackStatus == 'NonCashBack' &&
            model.costPlusAdjustment
          ) {
            return true;
          }
        },
        action: (model: any) => {
          this.$router.push({
            name: 'app.paymentreports.reconciliation.edit',
            params: { id: model.statementId, type: 'CashBack' },
          });
        },
      },
      {
        type: 'button',
        icon: 'fas fa-dollar-sign',
        title: 'Post To Dms',
        visible: (model: any) => {
          if (
            model.netTotal == '0' &&
            model.fee == '0' &&
            model.pendingReconcileCount == model.totalStatementCount &&
            model.cashBackStatus != 'CashBack' &&
            Number(model.actualStatementAmount) == Number(model.reconclieAmount)
          ) {
            return true;
          }
          return false;
        },
        action: (model: any) => {
          this.postReconcilToDms(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-dollar-sign',
        title: 'Post To Dms',
        color: 'green',
        visible: (model: any) => {
          if (
            model.netTotal == '0' &&
            model.fee == '0' &&
            model.pendingReconcileCount == 0 &&
            model.cashBackStatus != 'CashBack'
          ) {
            return true;
          }
          return false;
        },
        action: (model: any) => {
          this.showAlert(true, 'Data is already posted to DMS');
        },
      },
      {
        type: 'button',
        icon: 'fa fa-exclamation-triangle',
        title: 'Amount Mismatch',
        visible: (model: any) => {
          if (
            Number(model.actualStatementAmount) != Number(model.reconclieAmount)
          ) {
            return true;
          }
          return false;
        },
        action: (model: any) => {
          this.showAlert(false, `Statement Amount does not match with Actual Square amount which is : ${Number(model.actualStatementAmount) / 100} , Plese refresh data again.`);
        },
      }
    ];
  }

  public callMethod(methodName): void {
    if (methodName === 'resetFilters') {
      this.resetFilters();
    }

    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public postReconcilToDms(model) {
    this.syncDialog.model = true;
    this.cashBackStatus = model.cashBackStatus;
    this.statementId = model.statementId;
    this.totalNetAmount =
      model.netTotal > 0 ? model.netTotal / 100 : (model.netTotal / 100) * -1;
    this.sumOfFee = model.fee > 0 ? model.fee / 100 : (model.fee / 100) * -1;
  }

  public created(): void {
    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.params.startDate = this.$route.query.startDate.toString();
      this.params.endDate = this.$route.query.endDate.toString();
    } else {
      this.params.startDate = this.getMonthStartDate();
      this.params.endDate = this.presentDate();
    }
  }

  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'reconciliationList');
    if (!this.isFeatureToAccess('HasSquarePaymentProvider')) {
      this.$router.push({ name: 'app.dashboard' });
    }
    this.getReconcilationListPayments();
    this.setActions();
    this.setHeaders();
  }

  public setFromDateValue(date: any): void {
    this.currentDate = date;
  }

  public setHeaders() {
    this.reconcilHeader = [
      {
        text: 'Date',
        align: 'left',
        value: 'initiatedAt',
        sortable: true,
        fieldType: 'date',
      },
      {
        text: 'Deposit Number',
        align: 'left',
        value: 'reconciledDocNumber',
        sortable: false,
        fieldType: 'template',
        template: (model) => {
          if (
            model.netTotal == '0' &&
            model.fee == '0' &&
            model.pendingReconcileCount == 0 &&
            model.cashBackStatus != 'CashBack'
          ) {
            return `<span>${model.reconciledDocNumber}</span>`;
          }
          return `<span>N/A</span>`;
        },
      },
      {
        text: 'Unreconciled Net Total',
        align: 'left',
        value: 'netTotal',
        sortable: false,
        fieldType: 'template',
        template: (item) => {
          return `<span>${item.netTotal > 0 ? item.netTotal / 100 : (item.netTotal / 100) * -1
            }</span>`;
        },
      },
      {
        text: 'Unreconciled Fees',
        align: 'left',
        value: 'fee',
        sortable: false,
        fieldType: 'template',
        template: (item) => {
          return `<span>${item.fee > 0 ? item.fee / 100 : (item.fee / 100) * -1
            }</span>`;
        },
      },
      {
        text: 'Statement Amount',
        align: 'left',
        value: 'reconclieAmount',
        sortable: false,
        fieldType: 'template',
        template: (item) => {
          return `<span>${item.reconclieAmount / 100}</span>`;
        },
      },
      {
        text: 'Cost Plus Adjustment',
        align: 'left',
        value: 'costPlusAdjustment',
        sortable: false,
        fieldType: 'template',
        template: (item) => {
          return `<span>${item.costPlusAdjustment
            ? item.costPlusAdjustment > 0
              ? item.costPlusAdjustment / 100
              : (item.costPlusAdjustment / 100) * -1
            : 'N/A'
            }</span>`;
        },
      },
      {
        align: 'left',
        text: 'Action',
        isNotDataProp: true,
        sortable: false,
      },
    ];
  }

  public searchPayments(): void {
    const queryStringObj = Object.assign({}, this.pagination) as any;
    queryStringObj.startDate = this.params.startDate;
    queryStringObj.endDate = this.params.endDate;
    Utils.validateAndUpdateRoute(queryStringObj);

    if (this.params.startDate == '') {
      this.showAlert(false, 'Please select start Date');
      return;
    }
    if (this.params.endDate == '') {
      this.showAlert(false, 'Please select end Date');
      return;
    }
    this.getReconcilationListPayments();
  }

  public isShownCheckBox(item) {
    return item && !item.postingDetails.dmsStatus;
  }

  public addAttachment(attachment: any): boolean {
    if (attachment.selected) {
      this.selectedAttachments.push(attachment.settlementDetails.paymentId);
      this.totalNetAmount +=
        attachment.settlementDetails.netTotal &&
          attachment.settlementDetails.netTotal > 0
          ? attachment.settlementDetails.netTotal / 100
          : 0;

      this.sumOfFee +=
        attachment.settlementDetails && attachment.settlementDetails.fees > 0
          ? attachment.settlementDetails.fees
          : 0;
    } else {
      const index = this.selectedAttachments.indexOf(
        attachment.settlementDetails.paymentId
      );
      if (index > -1) {
        this.selectedAttachments.splice(index, 1);
        var totalAmountToSub =
          attachment.settlementDetails.netTotal &&
            attachment.settlementDetails.netTotal > 0
            ? attachment.settlementDetails.netTotal / 100
            : 0;

        this.totalNetAmount = this.totalNetAmount - totalAmountToSub;

        var totalFeeToSub =
          attachment.settlementDetails && attachment.settlementDetails.fees > 0
            ? attachment.settlementDetails.fees
            : 0;

        this.sumOfFee = this.sumOfFee - totalFeeToSub;
      }
    }

    return true;
  }

  public async getReconcilationListPayments(): Promise<void> {
    try {
      this.loading = true;
      const response = await paymentService.getReconciliationListAsync(
        this.params,
        this.pagination
      );
      this.reconcilList = response.results.filter(
        (x) => x.cashBackStatus != 'CashBack'
      );
      this.reconcilCashBackList = response.results;
      this.pagination.totalItems = response.total;
      const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
      if (pagination) {
        this.pagination = pagination;
        this.updatePaging(this.pagination);
      }
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any): void {
    this.pagination = paging;
    const queryStringObj = Object.assign({}, paging);
    if (queryStringObj) {
      queryStringObj.startDate = this.params.startDate;
      queryStringObj.endDate = this.params.endDate;
    }
    Utils.validateAndUpdateRoute(queryStringObj);
  }
}
